import {
  faCalendarDays,
  faPeopleRoof,
  faRestroom,
  faUsersViewfinder,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const BookingRightSideDetails = ({ cruiseDetails }) => {
  const { t } = useTranslation();
  return (
    <aside className="d-flex justify-end js-pin-content">
      <div className="w-360 lg:w-full d-flex flex-column items-center">
        <div className="px-30 py-30 rounded-4 border-light bg-white shadow-4">
          <div className="text-14 text-light-1">
            <span className="text-20 fw-500 ml-5 ">
              {cruiseDetails?.response?.itinerary.itineraryName ||
                t("common.nileCruise")}
            </span>
          </div>

          <div className="row y-gap-20 pt-30">
            <div className="col-12">
              <div className="searchMenu-date px-20 py-10 border-light rounded-4 -right js-form-dd js-calendar js-calendar-el">
                <div data-x-dd-click="searchMenu-date">
                  <h4 className="text-15 fw-500 ls-2 lh-16">{t("common.date")} </h4>

                  <div className="capitalize text-15 text-light-1 ls-2 lh-16">
                    <span className="js-first-date">
                      <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="  pe-1"
                      />{" "}
                      {cruiseDetails?.request?.operationDate}
                    </span>
                  </div>
                </div>

                <div
                  className="searchMenu-date__field shadow-2"
                  data-x-dd="searchMenu-date"
                  data-x-dd-toggle="-is-active"
                >
                  <div className="bg-white px-30 py-30 rounded-4">
                    <div className="elCalendar js-calendar-el-calendar"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="searchMenu-guests px-20 py-10 border-light rounded-4 js-form-dd js-form-counters">
                <div data-x-dd-click="searchMenu-guests">
                  <h4 className="text-15 fw-500 ls-2 lh-16 ">
                    {t("common.numberOfTravelers")}{" "}
                  </h4>
                  {cruiseDetails?.request?.cabins.map((cabin, i) => (
                    <div
                      key={i}
                      className={`text-15 text-light-1 ls-2 py-1 lh-16 ${
                        cruiseDetails?.request?.cabins.length - 1 > i
                          ? "border-bottom-light"
                          : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPeopleRoof} className="  pe-1" />{" "}
                      {t("common.room")}{cabin.cabinNumber} ({cabin.adults} {t("common.adults").toLowerCase()}
                      {cabin.adults > 1 ? "" : ""}
                      <>
                        {cabin.children > 0 ? (
                          <> & {cabin.children} {t("common.children").toLowerCase()}</>
                        ) : (
                          ""
                        )}
                      </>
                      )
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default BookingRightSideDetails;
